import ClinicNameRender from '@medical/components/ClinicNameRender'
import ClinicOpenTimeRender from '@medical/components/ClinicOpenTimeRender'
import EmploymentClassificationIcon, {
  getIconContent as getWorkPatternText,
} from '@medical/components/EmploymentClassificationIcon/EmploymentClassificationIcon'
import {
  COLORS,
  ENUM_ACCEPTED_WS,
  ENUM_MASS_RECRUITMENT,
  ENUM_AVAILABLE_SHIFT,
  ENUM_CANCELED_WS,
  ENUM_NOT_ACCEPTED_WS,
  ENUM_UNCONFIRMED_SHIFT,
} from '@medical/constant'
import { formatExtendedTime } from '@medical/libs/extendedTimeUtils'
import Router from '@medical/routes/router'
import moment from 'moment'
import React from 'react'

import { checkOverlapTime } from './checkOverlapTime'
import { Tooltip } from 'antd'
const minutesRounder = time => time

const TimingTypes = {
  working: 'working',
  breaking: 'breaking',
}

const dailyToTimeline = ({
  data: clinicalDepartments,
  clinicalDepartmentIds,
  statuses,
  departmentNames,
  regionIds,
  clinicIds,
}) => {
  const items = []
  const myMap = new Map()

  function calculateDuration(startTime, endTime) {
    const start = moment(startTime)
    const end = moment(endTime)
    const duration = moment.duration(end.diff(start))
    return duration.asMilliseconds()
  }

  const calculateBreakTimeValues = (workSchedules, type) => {
    let result = []
    if (type === 'workSchedule') {
      // eslint-disable-next-line no-unused-expressions
      const durationWhole = calculateDuration(
        workSchedules?.startTime,
        workSchedules?.endTime
      )

      let durationTime1
      let durationTime2
      let durationTime3
      let durationTime4

      if (workSchedules?.acceptedShift?.splitDateTime1) {
        const timingType = workSchedules?.acceptedShift
          .isSplitDateTime1BreakTime
          ? TimingTypes.breaking
          : TimingTypes.working

        durationTime1 = `${timingType}:${calculateDuration(
          workSchedules?.startTime,
          workSchedules?.acceptedShift?.splitDateTime1
        )}`
      }

      if (workSchedules?.acceptedShift?.splitDateTime2) {
        const timingType = workSchedules?.acceptedShift
          .isSplitDateTime2BreakTime
          ? TimingTypes.breaking
          : TimingTypes.working
        durationTime2 = `${timingType}:${calculateDuration(
          workSchedules?.acceptedShift?.splitDateTime1,
          workSchedules?.acceptedShift?.splitDateTime2
        )}`
      }

      if (workSchedules?.acceptedShift?.splitDateTime3) {
        const timingType = workSchedules?.acceptedShift
          .isSplitDateTime3BreakTime
          ? TimingTypes.breaking
          : TimingTypes.working
        durationTime3 = `${timingType}:${calculateDuration(
          workSchedules?.acceptedShift?.splitDateTime2,
          workSchedules?.acceptedShift?.splitDateTime3
        )}`
      }

      const lastPunch =
        workSchedules?.acceptedShift?.splitDateTime3 ||
        workSchedules?.acceptedShift?.splitDateTime2 ||
        workSchedules?.acceptedShift?.splitDateTime1 ||
        workSchedules?.startTime

      if (lastPunch) {
        const timingType = workSchedules?.acceptedShift?.isStartTimeBreakTime
          ? TimingTypes.breaking
          : TimingTypes.working
        durationTime4 = `${timingType}:${calculateDuration(
          lastPunch,
          workSchedules?.endTime
        )}`
      }

      let count = 0

      result = [durationTime1, durationTime2, durationTime3, durationTime4]
        .filter(Boolean)
        .map(item => {
          const [_type, time] = item.split(':')

          const res = {
            start: +(count / durationWhole).toFixed(4),
            width: +(+time / durationWhole).toFixed(4),
            type: _type,
          }
          count += +time

          return res
        })
    }

    if (type === 'availableShift') {
      const durationWhole = calculateDuration(
        workSchedules?.startTime,
        workSchedules?.endTime
      )

      let durationTime1
      let durationTime2
      let durationTime3
      let durationTime4

      if (workSchedules?.splitDateTime1) {
        const timingType = workSchedules?.isSplitDateTime1BreakTime
          ? TimingTypes.breaking
          : TimingTypes.working

        durationTime1 = `${timingType}:${calculateDuration(
          workSchedules?.startTime,
          workSchedules?.splitDateTime1
        )}`
      }

      if (workSchedules?.splitDateTime2) {
        const timingType = workSchedules?.isSplitDateTime2BreakTime
          ? TimingTypes.breaking
          : TimingTypes.working
        durationTime2 = `${timingType}:${calculateDuration(
          workSchedules?.splitDateTime1,
          workSchedules?.splitDateTime2
        )}`
      }

      if (workSchedules?.splitDateTime3) {
        const timingType = workSchedules?.isSplitDateTime3BreakTime
          ? TimingTypes.breaking
          : TimingTypes.working
        durationTime3 = `${timingType}:${calculateDuration(
          workSchedules?.splitDateTime2,
          workSchedules?.splitDateTime3
        )}`
      }

      const lastPunch =
        workSchedules?.splitDateTime3 ||
        workSchedules?.splitDateTime2 ||
        workSchedules?.splitDateTime1 ||
        workSchedules?.startTime

      if (lastPunch) {
        const timingType = workSchedules?.isStartTimeBreakTime
          ? TimingTypes.breaking
          : TimingTypes.working
        durationTime4 = `${timingType}:${calculateDuration(
          lastPunch,
          workSchedules?.endTime
        )}`
      }

      let count = 0

      result = [durationTime1, durationTime2, durationTime3, durationTime4]
        .filter(Boolean)
        .map(item => {
          const [_type, time] = item.split(':')

          const res = {
            start: +(count / durationWhole).toFixed(4),
            width: +(+time / durationWhole).toFixed(4),
            type: _type,
          }
          count += +time
          return res
        })
    }
    return result
  }

  const hasClinicalDepartments = clinicalDepartmentIds.length > 0;
  const hasClinics = clinicIds.length > 0;
  const hasRegions = regionIds.length > 0;

  const clinicalDepartmentSet = new Set(clinicalDepartmentIds);
  const clinicSet = new Set(clinicIds);
  const regionSet = new Set(regionIds);
  const WORK_SCHEDULE_ACTIVE_STATUSES = new Set([
    'WORKSCHEDULE_REJECT',
    'WORKSCHEDULE_DELETE',
  ]);

  const groups = clinicalDepartments
    .filter(({ id, clinic }) => {
      if (hasClinicalDepartments && !clinicalDepartmentSet.has(id)) {
        return false;
      }

      if (hasClinics && !clinicSet.has(clinic.id)) {
        return false;
      }

      return !(hasRegions && !regionSet.has(clinic.region));
    })
    // .sort((a, b) => a.clinic.order - b.clinic.order)
    .map((department, index) => {
      const { id, name, workSchedules, availableShifts } = department
      const filteredWorkSchedules = [];
      const workSchedulesDeleted = [];

      (workSchedules ?? []).forEach(ws => {
        if (!WORK_SCHEDULE_ACTIVE_STATUSES.has(ws.deletedStatus)) {
          filteredWorkSchedules.push(ws);
        }

        if (!ws.deletedAt) {
          workSchedulesDeleted.push(ws);
        }
      });

      const values = (availableShift, startTime, endTime) => {
        const {
          id: shiftId,
          isDoubleRecruitment,
          isPublished,
          isSpecial,
          isEarlySpecial,
        } = availableShift;

        const highlightColor = isDoubleRecruitment
          ? 'rgb(255,0,186)'
          : COLORS.normal;
        const startTimeFormat = moment(startTime)
        const endTimeFormat = moment(endTime)

        return {
          id: shiftId,
          group: id,
          title: `
          ${isDoubleRecruitment ? '(2診)' : ''}
          ${isPublished ? '' : '未 '}
          ${formatExtendedTime(startTime, startTime)} ~ ${formatExtendedTime(startTime, endTime)}
          ${`${isSpecial ? '(特別)' : ''}${isEarlySpecial ? '(早特)' : ''}`}`,
          start_time: startTimeFormat.unix() * 1000,
          end_time: endTimeFormat.unix() * 1000,
          bgColor: highlightColor,
          borderColor: highlightColor,
          color: '#fff',
          pathname: Router.get(Router.staffDetailAvailableShift, {
            availableShiftId: availableShift.id,
          }),
          breakTime: calculateBreakTimeValues(availableShift, 'availableShift'),
          case: 1,
          index,
        }
      }

      availableShifts.forEach(availableShift => {
        const startTime = minutesRounder(availableShift.startTime)
        const endTime = minutesRounder(availableShift.endTime)
        const availableStartTime = moment(availableShift.startTime).valueOf()
        const availableEndTime = moment(availableShift.endTime).valueOf()
        const rangeTime = (availableEndTime - availableStartTime) / 1000
        const isTimeGleOneHourly = rangeTime >= 3600
        if (statuses.includes(ENUM_AVAILABLE_SHIFT))
          items.push(values(availableShift, startTime, endTime))
        else if (
          statuses.includes(ENUM_UNCONFIRMED_SHIFT) ||
          (statuses.includes(ENUM_MASS_RECRUITMENT) && isTimeGleOneHourly)
        ) {
          if (workSchedulesDeleted.length > 0) {
            let rangeTimeWS = 0
            workSchedulesDeleted.forEach(ws => {
              const wsStartTime = moment(ws.startTime).valueOf()
              const wsEndTime = moment(ws.endTime).valueOf()

              if (
                checkOverlapTime(
                  availableStartTime,
                  availableEndTime,
                  wsStartTime,
                  wsEndTime
                )
              ) {
                if (wsEndTime > availableEndTime) {
                  rangeTimeWS += (availableEndTime - wsStartTime) / 1000
                } else if (wsStartTime < availableStartTime) {
                  rangeTimeWS += (wsEndTime - availableStartTime) / 1000
                } else {
                  rangeTimeWS += rangeTimeWS += (wsEndTime - wsStartTime) / 1000
                }
              }
            })
            const isCheck = rangeTime - rangeTimeWS >= 3600
            const isCheckMass = rangeTime - rangeTimeWS === rangeTime
            if (statuses.includes(ENUM_UNCONFIRMED_SHIFT) && isCheck) {
              items.push(items.push(values(availableShift, startTime, endTime)))
            } else if (
              statuses.includes(ENUM_MASS_RECRUITMENT) &&
              isCheckMass
            ) {
              items.push(items.push(values(availableShift, startTime, endTime)))
            }
          } else {
            items.push(items.push(values(availableShift, startTime, endTime)))
          }
        }
      })

      filteredWorkSchedules.forEach(workSchedule => {
        let item
        let checkScheduledAvailableShiftGroup
        const endTime = minutesRounder(workSchedule?.endTime)
        const startTime = minutesRounder(workSchedule?.startTime)
        const startDay = moment(workSchedule?.startTime).valueOf()
        const firstWorkday = moment(workSchedule?.doctor.firstWorkday).valueOf()
        const isFirstWorkday = startDay === firstWorkday

        const workScheduleDoctorWorkPattern = workSchedule?.doctor?.workPattern
        const workScheduleDoctorLastname = workSchedule?.doctor.lastname
        const workScheduleDoctorFirstname = workSchedule?.doctor.firstname
        const isPermanentDoctor = workScheduleDoctorWorkPattern === 'PERMANENT_DOCTOR';
        const startTimeMoment  = moment(startTime)
        const endTimeMoment  = moment(endTime)
        const workPatternText = getWorkPatternText(
          workScheduleDoctorWorkPattern
        )

        if (
          workSchedule?.deletedStatus !== 'WORKSCHEDULE_CANCEL' &&
          workSchedule?.acceptedShift &&
          workSchedule?.acceptedShift.scheduledAvailableShiftGroup &&
          workSchedule?.accepted &&
          workSchedule?.acceptedShift.deletedAt) {
          checkScheduledAvailableShiftGroup = true
        } else {
          item = {
            index,
            group: id,
            doctorId: workSchedule?.doctor?.id,
            contentData: {
              startTime: startTimeMoment,
              endTime: endTimeMoment,
              isPublished: workSchedule?.acceptedShift.isPublished,
              isDoubleRecruitment:
                workSchedule?.acceptedShift.isDoubleRecruitment,
              workScheduleDoctorWorkPattern,
              workScheduleDoctorLastname,
              workScheduleDoctorFirstname,
              isFirstWorkday,
            },
            id: workSchedule?.id,
            end_time: endTimeMoment.unix() * 1000,
            start_time: startTimeMoment.unix() * 1000,
            content: (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span>
                  {`
                    ${
                      workSchedule?.acceptedShift.isDoubleRecruitment
                        ? '(2診)'
                        : ''
                    }
                    ${workSchedule?.acceptedShift.isPublished ? '' : '未 '}
                    ${formatExtendedTime(workSchedule?.startTime, startTimeMoment)} ~ ${formatExtendedTime(
                    workSchedule?.startTime, endTimeMoment
                  )} (`}
                </span>
                <EmploymentClassificationIcon
                  workPattern={workScheduleDoctorWorkPattern}
                  className='timeline-icon-custom'
                />
                <span>{`
                  ${workScheduleDoctorLastname} ${workScheduleDoctorFirstname})${
                  isFirstWorkday ? ' ★' : ''
                }
                `}</span>
              </div>
            ),
            title: `${workPatternText}　${workScheduleDoctorLastname} ${workScheduleDoctorFirstname}`,
            pathname: Router.get(Router.staffDetailWorkSchedule, {
              workScheduleId: workSchedule?.id,
            }),
            acceptedShiftId: workSchedule?.acceptedShift?.id,
            breakTime: calculateBreakTimeValues(workSchedule, 'workSchedule'),
          }

          if (workSchedule?.deletedStatus === 'WORKSCHEDULE_CANCEL') {
            item.case = 2
            item.color = '#fff'
            item.bgColor = COLORS.canceled
            item.borderColor = COLORS.canceled
          } else if (
            workSchedule?.acceptedShift &&
            workSchedule?.acceptedShift.scheduledAvailableShiftGroup &&
            workSchedule?.accepted
          ) {
            const colorValue = isPermanentDoctor
              ? COLORS.fixedFulltime
              : COLORS.fixed

            item.case = 3
            item.bgColor = colorValue
            item.borderColor = colorValue
          } else {
            const isAccepted = workSchedule?.accepted;

            item.case = 4
            item.color = '#000'
            if (!isAccepted) {
              item.bgColor = COLORS.warning;
              item.borderColor = COLORS.warning;
            } else {
              const primaryColor = isPermanentDoctor
                ? COLORS.fixedFulltime
                : '#fff';

              item.bgColor = primaryColor;
              item.borderColor = isPermanentDoctor ? primaryColor : '#000';
            }
          }
        }

        if (
          !checkScheduledAvailableShiftGroup &&
          workSchedule?.accepted &&
          !workSchedule?.deletedStatus
        ) {
          if (statuses.includes(ENUM_ACCEPTED_WS)) {
            items.push(item)
          }
        } else if (
          !checkScheduledAvailableShiftGroup &&
          statuses.includes(ENUM_NOT_ACCEPTED_WS) &&
          !workSchedule?.deletedStatus
        ) {
          items.push(item)
        } else if (
          !checkScheduledAvailableShiftGroup &&
          statuses.includes(ENUM_CANCELED_WS)
        ) {
          items.push(item)
        }
      })

      let clinicName = `${ClinicNameRender({
        clinicalDepartment: department,
      })}`

      const clinicOpenTime = `${ClinicOpenTimeRender({
        clinicalDepartment: department,
      })}`
      const departmentName = departmentNames[name]
      const area = department.clinic?.Region?.name
      return {
        id,
        title: (
          <div className='tr'>
            <div
              style={{
                transform: 'scale(1)',
                transformOrigin: 'right',
                textAlign: 'center',
                width: '20%',
                fontSize: '12px',
              }}
              title={area}
            >
              {area && area.length > 4 ? `${area.substring(0, 4)}...` : area}
            </div>
            <Tooltip title={clinicName}>
              <div
                style={{ width: '20%', fontSize: '12px', textAlign: 'center' }}
              >
                {clinicName && clinicName.length > 7
                  ? `${clinicName.substring(0, 7)}...`
                  : clinicName}
              </div>
            </Tooltip>
            <Tooltip title={departmentName}>
              <div
                style={{
                  transform: 'scale(1)',
                  transformOrigin: 'right',
                  textAlign: 'center',
                  width: '20%',
                  fontSize: '12px',
                }}
              >
                {departmentName && departmentName.length > 5
                  ? `${departmentName.substring(0, 5)}...`
                  : departmentName}
              </div>
            </Tooltip>
            <div
              style={{
                width: '40%',
                fontSize: '12px',
                textAlign: 'center',
                transform: 'scale(1)',
                transformOrigin: 'right',
              }}
              title={clinicOpenTime}
            >
              {clinicOpenTime && clinicOpenTime.length > 20
                ? `${clinicOpenTime.substring(0, 30)}`
                : clinicOpenTime}
            </div>
            <Tooltip place='top' id='my-tooltip' />
          </div>
        ),
        rightTitle: name,
        stackItems: true,
      }
    })

  // const uniqueItems = removeDuplicate(items, 'id')
  const resultItems = []
  const seen = new Set()

  for (const item of items) {
    const value = item['id']
    if (!seen.has(value)) {
      seen.add(value)
      const key = `${item?.doctorId}`
      if (myMap.has(key)) {
        myMap.set(key, myMap.get(key) + 1)
      } else {
        myMap.set(key, 1)
      }
      resultItems.push(item)
    }
  }

  resultItems.forEach((e) => {
    const eValueContent = e.contentData
    if (myMap.get(e.doctorId) > 1) {
      e.content = (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span>（複）</span>
          <span>
            {`
                    ${eValueContent.isDoubleRecruitment ? '(2診)' : ''}
                    ${eValueContent.isPublished ? '' : '未 '}
                    ${formatExtendedTime(eValueContent.startTime, eValueContent.startTime)} ~ ${formatExtendedTime(eValueContent.startTime, eValueContent.endTime)} (`}
          </span>
          <EmploymentClassificationIcon
            workPattern={eValueContent.workScheduleDoctorWorkPattern}
            className='timeline-icon-custom'
          />
          <span>{`
                  ${eValueContent.workScheduleDoctorLastname} ${
            eValueContent.workScheduleDoctorFirstname
          })${eValueContent.isFirstWorkday ? ' ★' : ''}
                `}</span>
        </div>
      )
    }
  })
  return {
    groups,
    uniqueItems: resultItems,
  }
}

export default dailyToTimeline
